import { useEffect } from 'react';
import { useNavigate, useParams } from 'react-router-dom';
import { MainTracker } from '../PixelTrackers/MainTracker';

const MESSAGE_CODE = {
  'op': 'order_paid'
} as Record<string, string>;

const CHANNEL = {
  'twa': 'twillio_whatsapp',
  'tsms': 'twillio_sms'
} as Record<string, string>;

const WhatsAppRedirect: React.FC = () => {
  const navigate = useNavigate();
  const { country, order_hash_id, channel, message_code } = useParams<{ country: string; order_hash_id: string; channel: string; message_code: string }>();
  // channel: twa = twillio whatsapp, tws = twillio sms

  
  useEffect(() => {
    MainTracker.track('custom', 'Whatsapp Link Opened', {
      orderHashId: order_hash_id,
      channel: channel ? CHANNEL[channel] : 'unknown',
      messageCode: message_code ? MESSAGE_CODE[message_code] : 'unknown',
      phoneCountry: country ? country.toUpperCase() : 'unknown',
    });

    if (country && order_hash_id) {
      navigate(`/${country}/account/my-orders/${order_hash_id}/details`, { replace: true });
    }
  }, [country, order_hash_id, navigate]);

  return null; // This component doesn't render anything
};

export default WhatsAppRedirect;

